import { Center, Flex, Stack, useBreakpointValue } from '@chakra-ui/react'
import ScheduleConsultationButton from 'components/buttons/ScheduleConsultationButton'
import { Body1Strong } from 'components/typography'
import Link from 'next/link'
import { FC } from 'react'
import { forwardParams } from 'utils/forwardParams'

interface IconGridProps {
  links: { label: string; icon: JSX.Element; href?: string }[]
  cardWidth?: any
}

const IconGrid: FC<IconGridProps> = ({ links, cardWidth }) => {
  const actualCardWidth = cardWidth || { base: '150px', lg: '200px', '2xl': '300px' }

  return (
    <>
      <Flex wrap="wrap" sx={{ gap: '1rem' }} justify="center" pb="4">
        {links.map(({ label, icon, href }) =>
          href ? (
            <Link prefetch={false} href={forwardParams(href)} key={label}>
              <Stack
                w={actualCardWidth}
                align="center"
                boxShadow="md"
                p="4"
                rounded="lg"
                bg="white"
                _hover={{ transform: 'scale(1.1)' }}
                transition="transform 250ms ease-out"
                cursor="pointer"
              >
                <Center bg="green.50" rounded="full" w="60px" h="60px">
                  {icon}
                </Center>
                <Body1Strong textAlign="center">{label}</Body1Strong>
              </Stack>
            </Link>
          ) : (
            <Stack
              w={actualCardWidth}
              minH="150px"
              align="center"
              boxShadow="md"
              p="4"
              rounded="lg"
              bg="white"
              _hover={{ transform: 'scale(1.1)' }}
              transition="transform 250ms ease-out"
              key={label}
            >
              <Center p="3.5" bg="green.50" rounded="full" w="64px" h="64px">
                {icon}
              </Center>
              <Body1Strong textAlign="center">{label}</Body1Strong>
            </Stack>
          )
        )}
      </Flex>
      <ScheduleConsultationButton display={{ base: 'none', md: 'flex' }} size="lg" alignSelf="center" />
    </>
  )
}

export default IconGrid
